import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { PropagateLoader } from "react-spinners";
import CardTables from "../../../../atoms/CardTables";
import NoData from "../../../../atoms/NoData";
import moment from "moment";
import Button from "../../../../atoms/Button";
import { FaEye } from "react-icons/fa";
import useModal from "../../../../../hooks/useModal";
import Modal from "../../../../molecules/Modal";
import ViewReunion from "./ViewReunion";

const TableReuniones = ({ data, loading, accountants, admins, empresa }) => {
    const { open, close, isOpen } = useModal();
    const [reunion, setReunion] = useState();

    const handleOpen = (meet) => {
        setReunion(meet);
        open();
    };

    const handleClose = () => {
        setReunion(null);
        close();
    };

    const columns = [
        {name: "Asunto", selector: row => row.subject},
        {name: "Fecha", selector: row => moment(row.createdAt).format("DD/MM/YY hh:mm")},
        {name: "Acciones", cell: row => (
            <div className="flex flex-row space-x-4">
                <Button text={<FaEye size={22} />} bgColor="blue" width="w-10" onClick={()=>handleOpen(row)} />
            </div>
        )},
    ];

    const columnsResponsive = [
        {name: "Información", cell: row => (
            <div className="flex flex-col">
                <p> {row.subject} </p>
                <p> {moment(row.createdAt).format("DD/MM/YY hh:mm")} </p>
            </div>
        )},
        {name: "Acciones", cell: row => (
            <div className="flex flex-row space-x-4">
                <Button text={<FaEye size={22} />} bgColor="blue" width="w-10" onClick={()=>handleOpen(row)} />
            </div>
        )},
    ];

    return (
        <div>
            <CardTables>
                <div className="block md:hidden">
                    <DataTable
                        data={data}
                        columns={columnsResponsive}
                        progressPending={loading}
                        progressComponent={<div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div>}
                        noDataComponent={<NoData/>}
                        pagination
                    />
                </div>
                <div className="hidden md:block">
                    <DataTable
                        data={data}
                        columns={columns}
                        progressPending={loading}
                        progressComponent={<div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div>}
                        noDataComponent={<NoData/>}
                        pagination
                    />
                </div>
            </CardTables>
            {isOpen && reunion &&
                <Modal title="Reunión" onClose={handleClose} heigth="h-full" width="w-full" >
                    <ViewReunion reunion={reunion} accountants={accountants} admins={admins} empresa={empresa} />
                </Modal>
            }
        </div>
    );
};

export default TableReuniones;